<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/honor2" />
          <div class="mainbody" style="text-align: center">
            <success-list :data="list" title="计算机软件著作权登记证书" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/honor/componets/Banner'
import Tab from '@/views/honor/componets/Tab'
import SuccessList from '@/components/SuccessList'
export default {
  components: { Banner, Tab, SuccessList },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/',
      list: [
        {
          image: 'upload/about/004.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/005.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/006.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/007.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/008.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/009.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/010.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/011.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/012.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/013.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/014.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/015.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/016.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/017.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/018.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/019.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/020.png',
          title: '',
          text: ''
        },
        {
          image: 'upload/about/021.png',
          title: '',
          text: ''
        }
      ]
    }
  },
  mounted () {
    const list = []
    for (let i = 4; i <= 21; i++) {
      if (i < 10) {
        list.push({
          image: 'upload/about/00' + i + '.png',
          title: '',
          text: ''
        })
      } else {
        list.push({
          image: 'upload/about/0' + i + '.png',
          title: '',
          text: ''
        })
      }
    }
    // this.list = list
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/honor/honor2.vue